import { formatPriceAmount } from "../../../../../utils/numbers"
import {
	TableOrderArs,
	TableOrderCrypto,
	taxNames,
} from "../../../../tables/transactions-table/data/types"
import { CurrencyImage } from "../../../../tables/transactions-table/columns/currencyImageCell"
import { Heading2, Heading5, Heading6 } from "../../../../ui/texts/TextStyle"
import BodyBlock from "../BodyBlock"
import BodyItem from "../BodyItem"
import TaxesAccordion from "../TaxesAccordion"

const SuccessPaymentSummary = ({
	payment,
	variant,
}:
	| {
			payment: TableOrderArs
			variant: "transfer"
	  }
	| {
			payment: TableOrderCrypto
			variant: "crypto"
	  }) => {
	const comm_str =
		payment.commission && payment.commission.percent
			? `(${payment.commission.percent.toFixed(2)}% + IVA)`
			: ""
	console.log("SUCCESS PAYMENT SUMMARY", payment)
	switch (variant) {
		case "transfer":
			return (
				<BodyBlock title="Resumen">
					<BodyItem
						name="Solicitado"
						value={`${formatPriceAmount(payment.expected?.amount)} ${
							payment.expected?.currency
						}`}
					/>
					{payment.received?.amount && (
						<BodyItem
							name="Recibido"
							value={`${formatPriceAmount(payment.received.amount)} ${
								payment.received.currency
							}`}
						/>
					)}
					{payment.commission && payment.commission.commission && (
						<BodyItem
							name={`Comisión ${comm_str}`}
							value={`-${formatPriceAmount(
								payment.commission.commission.amount
							)} ${payment.commission.commission.currency}`}
						/>
					)}
					{payment.commission?.commissionTaxes &&
						payment.commission?.commissionTaxes?.map((tax) => {
							return (
								<BodyItem
									key={tax.tax_type}
									name={`${taxNames[tax.tax_type]} ${tax.tax_rate}%`}
									value={`-${formatPriceAmount(tax.tax_amount)} ARS`}
								/>
							)
						})}

					{payment.taxes && <TaxesAccordion tx={payment} />}

					<div className="flex justify-between items-center py-betweenComponents">
						<Heading6 className="font-medium text-text-muted">
							Acreditado
						</Heading6>
						{payment.credited && (
							<div className="flex-col  mb-2 whitespace-nowrap ">
								<div className="flex justify-end">
									<CurrencyImage currency={payment.credited.currency} />

									<Heading2 className="ml-betweenTexts font-medium whitespace-nowrap">
										{formatPriceAmount(
											payment.credited.amount,
											undefined,
											payment.credited.currency
										)}
									</Heading2>

									<Heading2 className="ml-betweenTexts font-light">
										{payment.credited.currency}
									</Heading2>
								</div>
								{/* {payment.creditedInRequestedCurrency && (
									<div className="flex justify-end">
										<Heading5 className="font-medium text-text-muted">
											{payment.creditedInRequestedCurrency.amount}{" "}
											{payment.creditedInRequestedCurrency.currency}
										</Heading5>
									</div>
								)} */}
							</div>
						)}
					</div>
				</BodyBlock>
			)
		case "crypto":
			return (
				<BodyBlock title="Resumen">
					<BodyItem
						name="Solicitado"
						value={`${formatPriceAmount(payment.expected?.amount)} ${
							payment.expected?.currency
						} ${
							payment.expected
								? `(${payment.expected.amount} ${payment.expected.currency})`
								: ""
						}`}
					/>
					{payment.received && (
						<BodyItem
							name="Recibido"
							value={`${formatPriceAmount(payment.received.amount)} ${
								payment.received.currency
							} ${
								payment.received && payment.received !== payment.received
									? `(${formatPriceAmount(payment.received.amount)} ${
											payment.received.currency
									  })`
									: ""
							}`}
						/>
					)}
					{payment.commission &&
						payment.commission.commissionInRequestedCurrency && (
							<BodyItem
								name="Comisión"
								value={`-${
									payment.commission.commissionInRequestedCurrency.amount
								} ${
									payment.commission.commissionInRequestedCurrency.currency
								} ${
									payment.commission.commission
										? `(-${payment.commission.commission.amount} ${payment.commission.commission.currency})`
										: ""
								}`}
							/>
						)}
					{payment.commission?.commissionTaxes?.map((tax) => (
						<BodyItem
							key={tax.tax_type}
							name={`${taxNames[tax.tax_type]} sobre comisión ${tax.tax_rate}%`}
							value={`-${formatPriceAmount(tax.tax_amount)} ${
								payment.currency
							}`}
						/>
					))}
					<div className="flex justify-between items-center py-betweenComponents">
						<Heading6 className="font-medium text-text-muted">
							Acreditado
						</Heading6>
						{payment.credited && (
							<div className="flex-col  mb-2 whitespace-nowrap ">
								<div className="flex justify-end">
									<CurrencyImage currency={payment.credited.currency} />

									<Heading2 className="ml-betweenTexts font-medium whitespace-nowrap">
										{formatPriceAmount(
											payment.credited.amount,
											undefined,
											payment.credited.currency
										)}
									</Heading2>

									<Heading2 className="ml-betweenTexts font-light">
										{payment.credited.currency}
									</Heading2>
								</div>
								{payment.creditedInRequestedCurrency && (
									<div className="flex justify-end">
										<Heading5 className="font-medium text-text-muted">
											{formatPriceAmount(
												payment.creditedInRequestedCurrency.amount
											)}{" "}
											{payment.creditedInRequestedCurrency.currency}
										</Heading5>
									</div>
								)}
							</div>
						)}
					</div>
				</BodyBlock>
			)
	}
}

export default SuccessPaymentSummary
